// extracted by mini-css-extract-plugin
module.exports = {"sticky":"CollectionTabs_sticky__lhpuP","not_sticky":"CollectionTabs_not_sticky__3vNPa"};